import { Injectable } from '@angular/core';
import { ExportInterface } from 'app/models/export.model';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';

@Injectable({
  providedIn: 'root',
})
export class ExportDataTransformGet extends DataTransformAbstractGet {
  transform(logExport: ExportInterface): ExportInterface {
    if (logExport.startAt) {
      logExport.startAt = this.normalizeDate(logExport.startAt.toString());
    }
    if (logExport.endAt) {
      logExport.endAt = this.normalizeDate(logExport.endAt.toString());
    }
    return logExport;
  }
}
